import _ from 'lodash';

export default class Supplier {
  constructor(data) {
    this.name = _.get(data, 'name', '');
    this.id = _.get(data, 'id', '');
  }
}
